import transformIn from './in';
import transformOut from './out';
import transformList from './list';

export default {
    in: transformIn,
    out: transformOut,
    list: transformList,
};
